/** will skip the form(s) inside that object(s) */
const wpcf7RestrictedFormsSelector = '.cc-wpcf7-no-thank-you-msg';

/**
 * @function wpcf7IsRestrictedForm checks if the form object is inside restricted parent(s)
 * @param {Object} formObj test form
 * @return {boolean} if found element with needed class
 */
function wpcf7IsRestrictedForm( formObj ) {
  return formObj.closest( wpcf7RestrictedFormsSelector ) !== null;
}

/**
 * function for toggling form controls (text inputs, textareas etc) readonly attr of the WPContactFrom7
 * @param {Object} formObj test form
 */
function wpcf7ToggleInputsDisability( formObj ) {
  const inputs = formObj.querySelectorAll( '.wpcf7-form-control-wrap .wpcf7-form-control' );
  for ( let i = 0; i < inputs.length; i += 1 ) {
    inputs[ i ].readOnly = ! inputs[ i ].readOnly;
  }
}

/**
 * action after the WPContactFrom7 form was submitted
 * @param {Object} formObj test form
 */
function wpcf7FormSubmitted( formObj ) {
  formObj.classList.add( 'wpcf7-hidden' );
}

document.addEventListener( 'DOMContentLoaded', () => {
  const wpcf7Forms = document.querySelectorAll( '.wpcf7 form' );
  wpcf7Forms.forEach( ( formObj ) => {
    if ( ! wpcf7IsRestrictedForm( formObj ) ) {
      /** turn on inputs readonly attr before form AJAX processed */
      formObj.addEventListener( 'submit', () => {
        wpcf7ToggleInputsDisability( formObj );
      } );

      /** turn off inputs readonly attr after form AJAX processed */
      formObj.addEventListener( 'wpcf7submit', () => {
        wpcf7ToggleInputsDisability( formObj );
      } );

      /** remove form after success */
      formObj.addEventListener( 'wpcf7mailsent', ( event ) => {
        const responseHTML = `<div class="ms-form__success"><h2 class="ms-form__title">Thank you!</h2><p class="ms-form__text">${ event.detail.apiResponse.message }</p></div>`;
        /** text between braces {{example}} in tag <a> and it will look like <a href='tel:example'>example</a> */
        const wrappedResponseHTML = responseHTML.replace( /\{{(.*?)\}}/, "<a href='tel:$1'>$1</a>" );
        formObj.insertAdjacentHTML( 'afterend', wrappedResponseHTML );

        if ( window.CallTrk ) {
          window.CallTrk.swap( formObj );
        }
        wpcf7FormSubmitted( formObj );
      } );
    }
  } );
} );
